import api from '../../store/api/api';

// Mirrors UberSiteCrewModal's parseAccessPoints -- flattens whichever shape
// /uber/get-request-zones responds with (a flat access_points list, a master_zone
// with sub_zones each carrying their own access_points, or a master_zone with
// access_points directly) into one flat list of { label, latitude, longitude }.
const parseAccessPoints = (data) => {
  if (data.access_points && Array.isArray(data.access_points)) {
    return data.access_points.map((ap) => ({
      label: ap.label,
      latitude: ap.latitude,
      longitude: ap.longitude,
    }));
  }

  if (data.master_zone) {
    if (data.master_zone.sub_zones && Array.isArray(data.master_zone.sub_zones)) {
      const accessPoints = [];
      data.master_zone.sub_zones.forEach((subZone) => {
        if (subZone.access_points && Array.isArray(subZone.access_points)) {
          subZone.access_points.forEach((ap) => {
            accessPoints.push({
              label: `${subZone.name} - ${ap.label}`,
              latitude: ap.latitude,
              longitude: ap.longitude,
            });
          });
        }
      });
      return accessPoints;
    }

    if (data.master_zone.access_points && Array.isArray(data.master_zone.access_points)) {
      return data.master_zone.access_points.map((ap) => ({
        label: ap.label,
        latitude: ap.latitude,
        longitude: ap.longitude,
      }));
    }
  }

  return [];
};

export const fetchRequestZones = async (latitude, longitude) => {
  const response = await api.get('/uber/get-request-zones', { latitude, longitude });
  return parseAccessPoints(response.data || {});
};

const MAX_REFINEMENT_STEPS = 5;

// Fully automatic version of the refinement UberSiteCrewModal does with a person
// picking from a dropdown (see its fetchRequestZones/renderAccessPointDropdown):
// there's no UI on this path, so it always takes the first (best) zone returned
// and re-queries at *that* zone's own coordinates, repeating until a query stops
// producing a materially different point -- walking down to the most specific
// access point available without anyone choosing between siblings along the way.
// Falls back to the original coordinates with a null label if the point isn't
// inside any Uber-defined zone at all (true for the vast majority of ordinary
// residential dropoffs -- this only actually refines anything for places like
// airports/stadiums/campuses that Uber has carved into specific request zones).
export const resolveDeepestRequestZone = async (latitude, longitude) => {
  let lat = latitude;
  let lon = longitude;
  let label = null;

  for (let i = 0; i < MAX_REFINEMENT_STEPS; i++) {
    let zones;
    try {
      zones = await fetchRequestZones(lat, lon);
    } catch {
      break;
    }

    const top = zones[0];
    if (!top || (top.latitude === lat && top.longitude === lon)) break;

    lat = top.latitude;
    lon = top.longitude;
    label = top.label;
  }

  return { lat, lon, label };
};

export default resolveDeepestRequestZone;
